function CalendarDotted(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="#A8ADB2"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M23 7h-1V5h-2v2h-8V5h-2v2H9c-1.11 0-1.99.9-1.99 2L7 23a2 2 0 002 2h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 16H9V13h14v10zm-10-6h-2v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm-8 4h-2v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2z" />
    </svg>
  )
}

export default CalendarDotted
